import { getRegion, getLocationByIp } from "@/api/user";
const user = {
  namespaced: true,
  state: {
    showLogin: false,
    showUserCenter: false,
    userInfo: null,
    isLogin: false,
    location: null,
    locationVisible: false,
    regionList: [],
    /* 结构为 
   [ {
    "id": 110000,
    "name": "北京",
    "children": [
        {
            "id": 110100,
            "name": "北京市",
            "children": []
        }
    ]
    }] 
    */
  },
  mutations: {
    showLogin(state) {
      state.showLogin = true;
    },
    hideLogin(state) {
      state.showLogin = false;
    },
    userInfo(state, payload) {
      state.userInfo = payload;
      if (payload) {
        localStorage.setItem("userInfo", JSON.stringify(payload));
        localStorage.setItem("sxpt_timestamp", Date.now());
        localStorage.setItem("refreshToken", payload.refreshToken);
        localStorage.setItem("Authorization", payload.accessToken);
      } else {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("sxpt_timestamp");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("Authorization");
      }
    },
    setLogin(state) {
      state.isLogin = true;
    },
    setLogout(state) {
      state.isLogin = false;
    },
    setLocation(state, payload) {
      state.location = payload;
    },
    setLocationVisible(state, payload) {
      state.locationVisible = payload;
    },
    setRegionList(state, payload) {
      state.regionList = payload;
    },
    setUserCenterVisible(state, payload) {
      state.showUserCenter = payload;
    },
  },
  actions: {
    setUserCenterVisible: ({ commit }, payload) => {
      commit("setUserCenterVisible", payload);
    },
    setLocation: ({ commit }, payload) => {
      commit("setLocation", payload);
    },
    setLocationVisible: ({ commit }, payload) => {
      commit("setLocationVisible", payload);
    },
    getRegion: async ({ commit }) => {
      const res = await getRegion();
      if (res) {
        commit("setRegionList", res);
      } else {
        commit("setRegionList", []);
      }
    },
    getIpInfo: async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        return data.ip;
      } catch (error) {
        console.error("Error fetching IP info:", error);
        return null;
      }
    },
    getLocationByIp: async ({ commit, dispatch }) => {
      Promise.all([dispatch("getIpInfo"), dispatch("getRegion")])
        .then(async ([ip]) => {
          const res = await getLocationByIp({
            ip,
          });
          // 结果可能为： '山东省 济南市' 或 '山东省 济南市 县'
          let normalized = "不限";
          if (res) {
            if (typeof res === "string") {
              const parts = res.trim().split(/\s+/);
              // 取最后一个 token 作为市级名称；如果最后一个没有市字样，仍然使用最后一个
              normalized = parts[parts.length - 1] || res;
              // 有时返回的是省+市（如 '山东省 济南市'），也可能只返回城市名（'济南'），统一保留市级中文，如果缺少 '市' 字，则尝试在省级 children 中匹配
              if (!/市$/.test(normalized) && normalized !== "不限") {
                // 尝试在 region 列表中寻找带 '市' 的匹配（如果 region 列表已加载）
                // 这里我们简单地保留原值，不强制添加 '市'
              }
            } else {
              // 如果返回对象，尝试提取 city 字段
              if (res.city) normalized = res.city;
              else if (res.name) normalized = res.name;
            }
          }
          commit("setLocation", normalized);
        })
        .catch((error) => {
          console.error("Error fetching location by IP:", error);
          commit("setLocation", "不限");
          commit("setLcationVisible", true);
        });
    },
    setShowLogin: ({ commit }) => {
      commit("showLogin");
      console.log("setShowLogin called");
    },
    setHideLogin: ({ commit }) => {
      commit("hideLogin");
      console.log("setHideLogin called");
    },
    setUserInfo: ({ commit }, payload) => {
      commit("userInfo", payload);
      if (payload) {
        commit("setLogin");
      } else {
        commit("setLogout");
      }
    },
    logout: ({ commit }) => {
      commit("userInfo", null);
      commit("setLogout");
    },
  },
  getters: {},
};

export default user;
